import { createStore, createHook } from "react-sweet-state";
import { listShiftApi } from "../api";

const initState = {
  isLoading: false,
  error: null,
  search: "",
  unitOrgs: [],
  limit: 10,
  skip: 0,
  total: 0,
  data: {
    personId: ""
  },
  dataObject: {},
};

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    ...initState,
  },
  // actions that trigger store mutation
  actions: {
    resetState:
      () =>
      async ({ setState, getState }) => {
        setState(initState);
      },
    updateStore:
      (newState) =>
      async ({ setState, getState }) => {
        setState(newState);
      },

    loadData:
      () =>
      async ({ setState, getState }) => {
        setState({ isLoading: true, error: null });

        let query = { ...getState() };

        try {
          const resp = await listShiftApi(query);

          if (resp.data && resp.data.code === 200) {
            const data = [...resp.data.data];
            const dataObject = {};
            data.forEach((item) => {
              dataObject[item._id] = item;
            });

            setState({
              data: data,
              dataObject: dataObject,
              total: resp.data.total,
              isLoading: false,
            });
            return true;
          }
        } catch (err) {
          setState({
            error: err && err.response ? err.response.data : "Unknown error",
            isLoading: false,
          });
          return false;
        }
      },
  },
  // optional, mostly used for easy debugging
  name: "listShiftService",
});

export const useListShiftStore = createHook(Store);
